import {Inject, Injectable} from "ng-metadata/core";
import {getVid} from "../../appConfig/appConfigForward";

const get = require('lodash/get');

@Injectable()
export class DirectLinkService{

    private readonly allowedAvailabilityCodesForExternalDirectLink : Set<string> =
        new Set([
            'ext_restrictedWithLink',
            'ext_restrictedWithLink_and_physical',
            'ext_restrictedNoLabel',
            'ext_not_restricted',
            'ext_not_restricted_and_physical'
        ]);

    private DIRECT_LINK_API_URL: string;
    private vid: string = getVid();
    constructor(@Inject('restBaseURLs') restBaseURLs,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('$q') private $q: ng.IQService){
        this.DIRECT_LINK_API_URL = restBaseURLs.directLink;
    }
    public getDirectLinkURL(item , isFullView , isOverlayFullView){
        let externalRecordDirectLink = this.getExternalRecordDirectLink(item);
        if (externalRecordDirectLink){
            return this.$q.resolve(externalRecordDirectLink);
        }

        let electronicServicesDirectLink = this.getElectronicServicesDirectLink(item);
        if (electronicServicesDirectLink && (isFullView || isOverlayFullView)){
            return this.$q.resolve(electronicServicesDirectLink);
        }

        let payload = {
            'doc':  item
        };
        let recordId = item.pnx.control.recordid[0];
        let queryParams= {
            'vid': this.vid
        };
        let httpConfig = {
            method: 'POST',
            url: this.DIRECT_LINK_API_URL + '/' + recordId,
            params: queryParams,
            data:  payload
        };
        return this.$http(httpConfig).then((response: { data: { redirect_to: string } }) => {
            return get(response, 'data.redirect_to');
        });
    }

    private getExternalRecordDirectLink(item) {
        let availabilityCodes = get(item, 'delivery.availability',[]);
        let availabilityLinks = get(item, 'delivery.availabilityLinks',[]);
        if (this.isAnyAvailabilityCodeAllowedForExternalDirectLink(availabilityCodes) &&
            availabilityLinks.indexOf('directlink') !== -1){
            return get(item, 'delivery.availabilityLinksUrl[0]');
        }
    }

    private isAnyAvailabilityCodeAllowedForExternalDirectLink(availabilityCodes: string[]): boolean {
        return availabilityCodes.some(availabilityCode =>
            this.allowedAvailabilityCodesForExternalDirectLink.has(availabilityCode)
        );
    }

    private getElectronicServicesDirectLink(item){
        return get(item, 'delivery.electronicServices[0].serviceUrl');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/directLink/directLink.service.ts